import styled from 'styled-components';

import { Text } from '@freenow/wave';

export const OneLineText = styled(Text)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
